import React, { useState, useEffect, useCallback } from 'react';
import {
  Checkbox,
  Button,
  ComboBox,
  WideAlert,
  FModal,
  LoadingIndicator,
  Icons,
} from '@components';
import { useSelector } from 'react-redux';
import { AlteracaoPercentualContribuicaoService } from '@services/alteracao-contribuicao';
import {
  mdiAlertCircleOutline,
  mdiCheckCircleOutline,
  mdiCommentAlertOutline,
} from '@mdi/js';

export const AlterarPercentualContribuicao = () => {
  const { matricula, plano } = useSelector((state) => state.user.data);
  const { alterar_perfil: showAlterarPerfil } = useSelector(
    (state) => state.configs.telasDisponiveis.data
  );

  const [loading, setLoading] = useState(false);
  const [statusRetTroca, setStatusRetTroca] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [percentualAtual, setPercentuallAtual] = useState('-%');
  const [percentualTroca, setPercentualTroca] = useState('');
  const [periodoTroca, setPeriodoTroca] = useState(false);
  const [termoAceite, setTermoAceite] = useState(false);

  const perfisParticipante = useCallback(async () => {
    setLoading(true);
    const alteracaoPercentualService =
      new AlteracaoPercentualContribuicaoService();
    const percentualVigente =
      await alteracaoPercentualService.getPercentualAtualParticipante(
        matricula,
        plano
      );
    setPercentuallAtual(percentualVigente);
    setLoading(false);
  }, [matricula, plano]);

  const recuperaTravas = useCallback(async () => {
    setLoading(true);

    const alteracaoPercentualService =
      new AlteracaoPercentualContribuicaoService();
    const dispAlterarPercentual =
      await alteracaoPercentualService.getVerificarDisponibilidadeAlterarContribuicao(
        matricula
      );

    setPeriodoTroca(dispAlterarPercentual);

    setLoading(false);
  }, [matricula]);

  const handleAlterarPercentual = async () => {
    setLoading(true);
    const alteracaoPercentualService =
      new AlteracaoPercentualContribuicaoService();

    const alteracaoPercentual =
      await alteracaoPercentualService.setMudancaPercentualContribuicaoParticipanteResult(
        {
          matricula,
          percentualAtual,
          percentualTroca,
        }
      );
    if (alteracaoPercentual) {
      setStatusRetTroca(true);
      setModalIsOpen(true);
    } else {
      setModalIsOpen(true);
    }
    setLoading(false);
  };

  useEffect(() => {
    perfisParticipante();
    recuperaTravas();
  }, [perfisParticipante, recuperaTravas]);

  return !loading ? (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col-12 col-md-8 col-lg-6">
            <h4 className="ts-8 fw-bold text-muted mb-2">
              Meu percentual de contribuições atual:
            </h4>
            <h1 className="ts-32 fw-bold text-grey mb-3">
              {`${percentualAtual}%`}
            </h1>
          </div>
        </div>
        <p className="ts-20 text-muted fw-bold text-orange">Informativo:</p>
        <ul className="ts-14 ms-0 my-2 ps-4 lh-base text-muted mb-32">
          <li>
            Com suas contribuições e as da patrocinadora, você possui uma
            reserva exclusiva em seu nome, que poderá ser utilizada em resgates
            parciais, renda mensal e outras opções.
          </li>
          <li>
            A patrocinadora contribui com o mesmo valor que você, até o limite
            de 100% do percentual. Havendo redução na sua contribuição, a dela
            será ajustada proporcionalmente.
          </li>
          <li>
            O percentual de contribuição poderá ser alterado a qualquer momento.
          </li>
          <li>
            As alterações feitas no mês vigente serão válidas a partir do mês
            seguinte. A atualização será exibida no extrato após o fechamento do
            mês de efetivação.
          </li>
          <li>
            Para acompanhar a efetivação, basta acessar o Histórico de Mudança
            de Percentual de Contribuição, e visualizar o andamento do seu
            pedido de alteração.
          </li>
        </ul>
        <WideAlert className="mb-4" iconClear={false}>
          <div className="d-block d-lg-flex align-items-center">
            <Icons
              path={mdiCommentAlertOutline}
              color="var(--primary-color)"
              size={2}
              style={{ marginRight: 4 }}
            />
            <p className="ts-16">
              <strong>Aviso importante:</strong> A alteração não aparecerá de
              imediato no extrato da conta de aposentaria. Para as alterações
              realizadas no mês vigente, a efetivação da alteração se dará no
              mês seguinte e a disponibilização dessa informação no extrato será
              após o fechamento do mês de efetivação da mudança.
            </p>
          </div>
        </WideAlert>
        <hr />

        {showAlterarPerfil &&
          (periodoTroca ? (
            <>
              <div className="d-flex mb-32 mt-32">
                <Checkbox
                  className="beneficiario_checkbox"
                  defaultChecked={termoAceite}
                  onChange={setTermoAceite}
                  disabledCheckbox={termoAceite}
                />
                <p className="text-muted ts-14">
                  Declaro ter recebido da Forluz as informações e
                  esclarecimentos necessários e suficientes para as minhas
                  escolhas, as quais são feitas sob minha inteira
                  responsabilidade, declarando, ainda, estar ciente, sem
                  discordância, dos itens descritos acima.
                </p>
              </div>
              <div className="row mb-32 mt-32">
                <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                  <div className="row">
                    <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                      <ComboBox
                        id="percentualContribuicao"
                        options={[
                          '50',
                          '75',
                          '90',
                          '100',
                          '125',
                          '150',
                          '200',
                        ].map((x) => {
                          return { value: x, label: x };
                        })}
                        isDisabled={!termoAceite}
                        value={percentualTroca}
                        onChange={setPercentualTroca}
                        name="percentualContribuicao"
                        label="Selecione o percentual de contribuição"
                      />
                    </div>
                    <div className="col-12 col-lg-4 mb-3 ">
                      <Button
                        disabled={!termoAceite}
                        className="mt-4"
                        onClick={async () => {
                          await handleAlterarPercentual();
                        }}
                      >
                        Alterar
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <WideAlert className="mb-4" iconClear={false}>
              <div className="d-block d-lg-flex align-items-center">
                <Icons
                  path={mdiCommentAlertOutline}
                  color="var(--primary-color)"
                  size={2}
                  style={{ marginRight: 4 }}
                />
                <p className="ts-16">
                  <strong>Aviso importante:</strong> Não é possível solicitar
                  alteração, pois está fora do período de solicitação.
                </p>
              </div>
            </WideAlert>
          ))}

        <FModal
          isOpen={modalIsOpen}
          close
          onClose={() => setModalIsOpen(false)}
        >
          {statusRetTroca ? (
            <>
              <Icons
                path={mdiCheckCircleOutline}
                color="var(--success)"
                size={2}
              />
              <h1 className="ts-20 fw-bold mb-1">Dados atualizados</h1>
              <p className="ts-16">
                No próximo mês seu percentual de contribuição será alterado
              </p>
            </>
          ) : (
            <>
              <Icons
                path={mdiAlertCircleOutline}
                color="var(--error)"
                size={2}
              />

              <h1 className="ts-20 fw-bold mb-1">Ocorreu um erro</h1>
              <p className="ts-16">Entre em contato com a Forluz</p>
            </>
          )}
        </FModal>
      </div>
    </div>
  ) : (
    <LoadingIndicator />
  );
};
